module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h640v479.997H0z\"/><path fill=\"#005700\" d=\"M0 0h213.331v479.997H0z\"/><path fill=\"#fc0000\" d=\"M426.663 0h213.331v479.997H426.663z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/it.svg
// module id = 52
// module chunks = 0